import React from 'react';
import { Box } from '@mui/material';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import { useStyles } from './styles';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import SecondaryButton from '../button/secondaryButton';
import { useNavigate } from 'react-router-dom';
import { RoutesConstants } from '@/main/routes/routesConstants';
interface Props {
  styles?: React.CSSProperties;
  messageCustom?: string | null;
  withButtonBack?: boolean;
}

export default function ResultNotFoundComponent({
  styles,
  messageCustom,
  withButtonBack = false,
}: Props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const handleBack = () => navigate(-1)

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      padding="5px"
      alignItems="center"
      style={styles || {}}>
      <FindInPageIcon className={classes.iconResultFound} />
      <span className={classes.messageResultFound}>
        {!isNullUndefined(messageCustom) ? messageCustom : getTranslateByKey('information.noRecordsFound')}
      </span>
      {withButtonBack && (
        <SecondaryButton
          id='id-reassignOrder-button-back'
          type='button'
          onClick={handleBack}
          style={{ marginLeft: 'auto' }}
        >
          {getTranslateByKey('information.back')}
        </SecondaryButton>
      )}
    </Box>
  );
}
